<template>
  <div class="problemStatistics">
    <div class="total">
      <div class="icon">
        <img :src="statistics" alt="统计">
      </div>
      <div>
        <span class="title">审图总人数</span>
        <p class="num"> {{num}} </p>
      </div>
    </div>
    <div class="statistics">
      <div class="spec">
        <div class="title">
          <div class="title_left">
            <el-divider direction="vertical"></el-divider>
            <span>问题专业占比</span>
          </div>
          <div class="title_right">
            <el-radio-group v-model="category" size="small" @change="setOption">
              <el-radio-button :label="1">
                2D问题
              </el-radio-button>
              <el-radio-button :label="2">
                3D问题
              </el-radio-button>
              <el-radio-button :label="3">
                文件问题
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div id="specChart2" ref="specChart" class="circleSlider"></div>
        <!-- <div v-if='specDistribution.length>0' class='tableBox'> -->
          <!-- <ul>
            <li v-for='(item,index) in title' :key='index'>{{item}}</li>
          </ul>
          <ul>
            <li v-for='(item,index) in specDistribution' :key='index'>
              {{item}}
            </li>
          </ul> -->
          <!-- <el-table ref="Table" :data="specDistribution" height="215px" :cell-style="cellStyle" :header-cell-style="headerStyle">
            <el-table-column prop="color" label="" align="center" v-slot='{row}' width="30">
              <p style='width:8px;height:8px' :style="{background:row.color}"></p>
            </el-table-column>
            <el-table-column prop="specName" label="专业" align="center"/>
            <el-table-column prop="ratio" label="占比" align="center"/>
            <el-table-column prop="totalNum" label="问题数" align="center"/>
          </el-table> -->
        <!-- </div> -->
      </div>
      <div class="bulletinBoard">
        <div class="title_left">
          <el-divider direction="vertical"></el-divider>
          <span>问题看板</span>
        </div>
        <div id="severityChart2" ref="severityChart" class="circleSlider"></div>
      </div>
    </div>
  </div>
</template>

<script>
import question from "@/xgzdService/question-service"
import { mapState } from 'vuex'
import * as echarts from 'echarts';
var specChart; // 问题专业分布图
var severityChart; // 严重等级分布图
export default {
  data(){
    return{
      num:0,
      statistics:require(`@/views/assets/statistics.png`),
      specDistribution:[],
      severityLevelDistribution:[],
      category:1,
      title:['','专业','占比','问题数']
    }
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
    })
  },
  methods:{
    async queryPrjQuestionStatus(){
      const { prjId } = this.prjInfo
      const res1 = await question.prjDrawingReviewers(prjId);
      this.num = res1.data;
    },
    init() {
      this.queryPrjQuestionStatus()
      specChart = echarts.init(this.$refs.specChart); // 问题专业分布图
      severityChart = echarts.init(this.$refs.severityChart); // 严重等级分布图
      this.setOption();
    },
    async getQuestionDashboard() {
      const { prjId } = this.prjInfo
      const res1 = await question.prjSpecQuestion(prjId,this.category);
      this.specDistribution = res1.data;
      const res2 = await question.prjQuestionStatus(prjId);
      this.severityLevelDistribution = res2.data;
    },
    setOption() {
      this.getQuestionDashboard().then(() => {
        // 问题专业分布图,严重等级分布图
        let legendData = [];
        let seriesData = [];
        const option = {
          title: {
            text: "",
            top: "46%",
            left: "22.5%",
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              fontWeight: "bold",
              color: "#666666",
            }
          },
          // 图例
          legend: {
            type: "scroll",
            orient: "vertical", // 垂直布局
            left: "65%",
            y: "center",
            itemGap:5,
            itemWidth:8,
            itemHeight:8,
            data: [],
            textStyle:{
              fontSize:14,
              align:'left',
              padding:[2,8,2,8],
              lineHeight:32,
              backgroundColor:'#e0f0ff66',
            },
            selectedMode: true,
            data: [],
          },
          // 列表
          series: [
            {
              type: "pie",
              radius: ["58%", "80%"],
              center: ["32%", "50%"],
              label: {},
              rich:{},
              data: []
            }
          ],
          // 提示
          tooltip: {
            trigger: "item",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [10, 30, 10, 10],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px", // 行高
            formatter(e) {
              return e.marker + " " + e.name.split('   ')[0] + "<br>" + "&nbsp;&nbsp;&nbsp;&nbsp;" + "问题数：" + e.value +"个" +"&nbsp;&nbsp;&nbsp;&nbsp;" +  e.percent + "%";
            }
          }
        };

        const tot = this.specDistribution.reduce((sum, e) => sum + Number(e.totalNum || 0), 0)
        const specList = this.specDistribution;
        legendData = specList.map((item) => item.specName+'   '+item.ratio+'   '+item.totalNum);
        seriesData = specList.map((item) => {
          return { name: item.specName+'   '+item.ratio+'   '+item.totalNum, value: item.totalNum,ratio: item.ratio};
        });
        option.legend.data = legendData;
        option.series[0].data = seriesData;
        option.series[0].label = {
          show: true,
          position:'center',
          formatter:function(){
            let str = '{a|'+ tot+'}' + '\n\n' +'{b|总问题数}'
            return str
          },
        };
        option.series[0].label.rich = {
          a:{
            color:'#333333',
            fontSize:'20',
            fontWeight:'600'
          },
          b:{
            fontSize:'13',
            color:'#333333',
          }
        },
        specChart.setOption(option, true);
        const colors = specChart.getOption().color;
        if(colors.length>0){
          this.specDistribution.forEach((item,index) => {
            item.color = colors[index]
          })
        }
        
        const tot2 = this.severityLevelDistribution.reduce((sum, e) => sum + Number(e.totalNum || 0), 0)
        const severityList = this.severityLevelDistribution;
        legendData = severityList.map((item) => item.queStatus);
        seriesData = severityList.map((item) => {
          return { name: item.queStatus, value: item.totalNum };
        });
        option.legend.data = legendData;
        option.legend.show = true;
        // option.legend.textStyle.rich.a.width = 50;
        option.series[0].data = seriesData;
        option.series[0].label = {
          show: true,
          position:'center',
          formatter:function(){
            let str = '{a|'+ tot2+'}' + '\n\n' +'{b|总问题数}'
            return str
          },
        },
        option.series[0].label.rich = {
          a:{
            color:'#333333',
            fontSize:'20',
            fontWeight:'600'
          },
          b:{
            fontSize:'13',
            color:'#333333',
          }
        },
        severityChart.setOption(option, true);
      });
    },
    headerStyle() {
      return "background-color:#fff !important;height:32px;padding:0px;border:none";
    },
    cellStyle() {
      return "height:32px;border:none;margin-bottom: 10px;";
    },
  }
}
</script>

<style lang="scss" scoped>
.problemStatistics{
  padding: 20px;
  .total{
    display: flex;
    justify-content: space-evenly;
    border:1px solid #D4D9EC;
    border-radius:15px;
    padding:12px 0px;
    width: 180px;
    margin-left:20px;
    .title{
      font-size:14px;
      color:#333333
    }
    .num{
      font-size:16px;
      color:#323232;
      font-weight:600;
    }
  }
  .statistics{
    display: flex;
    margin-top: 20px;
    .spec{
      border:1px solid #E1ECF6;
      width:706px;
      height:368px;
      margin-right:20px;
      padding:20px;
      position: relative;
    }
    .bulletinBoard{
      border:1px solid #E1ECF6;
      width:706px;
      height:368px;
      padding:20px
    }
    .title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      
    }
    .title_left {
      display: flex;
      align-items: center;
      .el-divider {
        background-color: var(--theme-color);
        width: 3px;
        height: 15px;
        margin: 0 8px 0 0;
      }
      span {
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        color: var(--key-color);
        white-space: nowrap;
      }
    }
    .title_right{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    
    .circleSlider {
      width: 500px;
      height: 280px;
    }
  }
  .tableBox{
    position: absolute;
    top:80px;
    right:80px;
  }
}
</style>